module.exports = "/_next/static/images/parallax-3-d31bc32c51a32c062227367cc74b3aae.jpg.webp";